import { render, staticRenderFns } from "./tuTarifa.vue?vue&type=template&id=5c6997ba&scoped=true&"
import script from "./tuTarifa.vue?vue&type=script&lang=js&"
export * from "./tuTarifa.vue?vue&type=script&lang=js&"
import style0 from "./tuTarifa.vue?vue&type=style&index=0&id=5c6997ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6997ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VRow,VSheet})
